import moment from 'moment';
import EventModel from '../models/EventModel';

/**
 * 현재 시간이 사용 가능한 시간인지 여부
 * @param useStartTime 사용 시작 시간
 * @param useEndTime 사용 종료 시간
 * @returns 사용 가능 여부
 */
export const checkUseTime = (useStartTime, useEndTime) => {
  // 설정된 시간 값이 없으면 true 리턴
  if (!useStartTime || !useEndTime) return true;

  // 현재 시간 조회(HHmm)
  const currentTime = Number(moment().format('HHmm'));
  const startTime = Number(useStartTime);
  const endTime = useEndTime === '0000' ? 2400 : Number(useEndTime);

  if (startTime <= endTime) {
    // 시작시간이 종료시간보다 작거나 같은 경우 당일 기준으로 계산
    return currentTime >= startTime && currentTime <= endTime;
  } else {
    // 시작시간이 종료시간보다 큰경우 당일 ~ 다음날까지로 계산
    return currentTime >= startTime || currentTime <= endTime;
  }
};

/**
 * 메뉴 데이터 정렬
 * @param storeData 메뉴 데이터
 */
export const applyMenuDataSorting = storeData => {
  storeData.menuGroups.sort(function (a, b) {
    return a.locZ - b.locZ || a.locY - b.locY || a.locX - b.locX;
  });
  storeData.menus.sort(function (a, b) {
    return a.locZ - b.locZ || a.locY - b.locY || a.locX - b.locX;
  });
  storeData.toppingGroups.sort(function (a, b) {
    return a.locZ - b.locZ || a.locX - b.locX;
  });
  storeData.toppings.sort(function (a, b) {
    return a.locZ - b.locZ || a.locY - b.locY || a.locX - b.locX;
  });
  storeData.setMenuGroups.sort(function (a, b) {
    return a.groupCode - b.groupCode;
  });
  storeData.setMenus.sort(function (a, b) {
    return (
      Number(a.itemCode) - Number(b.itemCode) ||
      a.groupCode - b.groupCode ||
      Number(a.setMenuCode) - Number(b.setMenuCode)
    );
  });
};

/**
 * 이벤트 데이터를 Map으로 변환
 * @param events 이벤트 데이터
 * @param eventItems 이벤트 아이템 데이터
 * @returns
 */
export const generateEventMap = (events, eventItems) => {
  const eventMap = new Map();
  const currentDate = moment().startOf('day');
  const currentTime = moment().format('HHmm');

  if (events.length === 0) return eventMap;
  if (eventItems.length === 0) return eventMap;

  // 행사 아이템을 Map으로 변환
  events.forEach(event => {
    // 행사 기간 검사
    const startDate = moment(event.startDate).startOf('day');
    const endDate = moment(event.endDate).startOf('day');
    if (!currentDate.isBetween(startDate, endDate, null, '[]')) return;

    // 행사 시간이 존재하는 경우 시간 검사
    if (event.startTime && event.endTime) {
      if (currentTime < event.startTime || currentTime >= event.endTime) return;
    }

    // 해당 하는 이벤트 아이템
    eventItems.forEach(eventItem => {
      if (event.eventCode === eventItem.eventCode) {
        // 중복되는 아이템코드가 있는 경우 덮어쓰기
        eventMap.set(eventItem.itemCode, new EventModel({ ...event, ...eventItem }));
      }
    });
  });

  return eventMap;
};
